// removed by extract-text-webpack-plugin
module.exports = {"errors":"_1UqI8P7-8o4ARxx_q6D0b2","modal":"_32dr2e2IWQjw14FX3GCA9w","report":"_1WAAYjAp0LYiCdtxXLcZAj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImportRecipientsCSVButton/ImportRecipientsCSVButton.scss
// module id = 1274
// module chunks = 1